"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymizedOrderForRegionalManager = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const AnonymizedPassenger_1 = require("../models/AnonymizedPassenger");
const OrderContentLocation_1 = require("../models/OrderContentLocation");
const OrderCustomLocation_1 = require("../models/OrderCustomLocation");
const VehicleTypePriceFee_1 = require("../models/VehicleTypePriceFee");
const OrderStatus_1 = require("./OrderStatus");
const PaymentMethod_1 = require("./PaymentMethod");
const SimpleOrderContentLocation_1 = require("./SimpleOrderContentLocation");
const SimpleOrderCustomLocation_1 = require("./SimpleOrderCustomLocation");
let AnonymizedOrderForRegionalManager = class AnonymizedOrderForRegionalManager {
    _id;
    departureAt;
    originLocationId;
    destinationLocationId;
    pricingCountryId;
    // TODO @MaxLength
    pickupAddress;
    // TODO @MaxLength
    dropoffAddress;
    passengers;
    vehicles;
    tollPrice = 0;
    tollFee = 0;
    additionalPrice = 0;
    additionalFee = 0;
    price;
    fee;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    discountIds = [];
    vehicleTypesPricesFees = [];
    contentLocations = [];
    customLocations = [];
    acceptedAt = undefined;
    declinedAt = undefined;
    confirmedAt = undefined;
    cancelledAt = undefined;
    driverNote = "";
    originLocationName;
    destinationLocationName;
    simpleOrderContentLocations = [];
    simpleOrderCustomLocations = [];
    paymentMethod = PaymentMethod_1.PaymentMethod.Online;
    status;
};
exports.AnonymizedOrderForRegionalManager = AnonymizedOrderForRegionalManager;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], AnonymizedOrderForRegionalManager.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "originLocationId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "destinationLocationId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "pricingCountryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "pickupAddress", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "dropoffAddress", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => AnonymizedPassenger_1.AnonymizedPassenger),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "passengers", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "vehicles", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "tollPrice", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "tollFee", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "additionalPrice", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "additionalFee", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "fee", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "pricingCurrency", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "discountIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypePriceFee_1.VehicleTypePriceFee),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "vehicleTypesPricesFees", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderContentLocation_1.OrderContentLocation),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "contentLocations", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCustomLocation_1.OrderCustomLocation),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "customLocations", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForRegionalManager.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForRegionalManager.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForRegionalManager.prototype, "confirmedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? null : new Date(value))),
    __metadata("design:type", Object)
], AnonymizedOrderForRegionalManager.prototype, "cancelledAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "driverNote", void 0);
__decorate([
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "originLocationName", void 0);
__decorate([
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AnonymizedOrderForRegionalManager.prototype, "destinationLocationName", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SimpleOrderContentLocation_1.SimpleOrderContentLocation),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "simpleOrderContentLocations", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SimpleOrderCustomLocation_1.SimpleOrderCustomLocation),
    __metadata("design:type", Array)
], AnonymizedOrderForRegionalManager.prototype, "simpleOrderCustomLocations", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "paymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AnonymizedOrderForRegionalManager.prototype, "status", void 0);
exports.AnonymizedOrderForRegionalManager = AnonymizedOrderForRegionalManager = __decorate([
    (0, class_transformer_1.Exclude)()
], AnonymizedOrderForRegionalManager);
//# sourceMappingURL=AnonymizedOrderForRegionalManager.js.map